import { ThemeProvider } from './components/ThemeProvider';
import { PanelBoundary } from './components/PanelBoundary';
import { TopBar } from './components/TopBar';
import type { CardAccent } from './components/Card';

import { BitcoinPanel } from './panels/Bitcoin/BitcoinPanel';
import { WeatherPanel } from './panels/Weather/WeatherPanel';
import { MusicPanel } from './panels/Music/MusicPanel';
import { CalendarPanel } from './panels/Calendar/CalendarPanel';
import { HealthPanel } from './panels/Health/HealthPanel';
import { TodosPanel } from './panels/Todos/TodosPanel';
import { MediaPanel } from './panels/Media/MediaPanel';
import { QuotePanel } from './panels/Quote/QuotePanel';

/** Row-major, matching spec.md's Layout table exactly. */
const SLOTS: ReadonlyArray<{
  key: string;
  title: string;
  accent: CardAccent;
  Panel: () => JSX.Element;
}> = [
  { key: 'bitcoin', title: 'Bitcoin', accent: 'btc', Panel: BitcoinPanel },
  { key: 'weather', title: 'Weather', accent: 'sky', Panel: WeatherPanel },
  { key: 'music', title: 'Music', accent: 'music', Panel: MusicPanel },
  { key: 'calendar', title: 'Calendar', accent: 'cal', Panel: CalendarPanel },
  { key: 'health', title: 'Daily Health', accent: 'health', Panel: HealthPanel },
  { key: 'todos', title: 'Aspirations & Todos', accent: 'todo', Panel: TodosPanel },
  { key: 'media', title: 'Media Tracker', accent: 'media', Panel: MediaPanel },
  { key: 'quote', title: 'Quote of the Day', accent: 'quote', Panel: QuotePanel },
];

export default function App() {
  return (
    <ThemeProvider>
      {/* h-screen + overflow-hidden: the whole app is exactly one viewport. */}
      <div className="flex h-screen w-screen flex-col overflow-hidden bg-surface text-ink">
        <TopBar />
        {/*
          flex-1 min-h-0  -> the grid takes the remaining height and is ALLOWED
                             to be shorter than its content. min-h-0 is the fix
                             for flex/grid items defaulting to min-height:auto
                             ("never shrink below content"), which is THE cause
                             of the whole-page-scrolls bug.
          grid-rows-2     -> two equal 1fr rows, so both rows are exactly half.
          overflow-hidden -> a misbehaving panel clips instead of scrolling the page.
        */}
        <main
          className="grid min-h-0 flex-1 grid-cols-4 grid-rows-2 gap-3 overflow-hidden p-3"
          data-testid="panel-grid"
        >
          {SLOTS.map(({ key, title, accent, Panel }) => (
            // min-h-0 / min-w-0 on the CELL as well as on the Card: both needed.
            <div key={key} className="min-h-0 min-w-0">
              <PanelBoundary title={title} accent={accent}>
                <Panel />
              </PanelBoundary>
            </div>
          ))}
        </main>
      </div>
    </ThemeProvider>
  );
}
